import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import { useFirebase } from "./useFirebase";
import { useAuth } from "./FirebaseAuthContext";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import { Dashboard, AdminPanelSettings } from "@mui/icons-material";

export default function AccountMenu() {
  const { auth } = useFirebase();
  const { user, userData, loadingUser } = useAuth();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSignOut = () => {
    auth.signOut();
    navigate("/login");
    handleClose();
  };

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        {!loadingUser && user && (
          <Tooltip title="Settings">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar
                src={user.photoURL ?? undefined}
                alt={user.displayName ?? ""}
              />
            </IconButton>
          </Tooltip>
        )}
        {!loadingUser && !user && (
          <Button
            color="inherit"
            onClick={() => navigate("/login")}
            size="small"
          >
            Login
          </Button>
        )}
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={() => navigate("/account")}>
          <Avatar /> My account
        </MenuItem>
        <Divider />
        {/*<MenuItem>*/}
        {/*  <ListItemIcon>*/}
        {/*    <PersonAdd fontSize="small" />*/}
        {/*  </ListItemIcon>*/}
        {/*  Invite team member*/}
        {/*</MenuItem>*/}
        <MenuItem onClick={() => navigate("/boards")}>
          <ListItemIcon>
            <Dashboard fontSize="small" />
          </ListItemIcon>
          Boards
        </MenuItem>
        {userData?.isAdmin && (
          <MenuItem onClick={() => navigate("/admin")}>
            <ListItemIcon>
              <AdminPanelSettings fontSize="small" />
            </ListItemIcon>
            Admin
          </MenuItem>
        )}
        {/*<MenuItem>*/}
        {/*  <ListItemIcon>*/}
        {/*    <Settings fontSize="small" />*/}
        {/*  </ListItemIcon>*/}
        {/*  Settings*/}
        {/*</MenuItem>*/}
        <MenuItem onClick={handleSignOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
